import styled, { css, DefaultTheme } from 'styled-components';
import {
  Row,
  Text,
  RedCancel as DefaultRedCancel,
  Column as DefaultColumn,
} from '~components';

import DefaultSearch from '~components/svgs/Search';
import { ContainerProps, StatusDescriptionProps } from './types';

function backgroundVariant(
  $variant: 'pending' | 'denied',
  theme: DefaultTheme
) {
  const backgroundColors = {
    pending: theme.color.support.orange.weak,
    denied: theme.color.background.brand.weakest,
  };

  return backgroundColors[$variant];
}

export const Container = styled(Row)<ContainerProps>`
  padding-top: ${({ theme }) => theme.spacing.km4};
  padding-bottom: ${({ theme }) => theme.spacing.km4};
  padding-left: ${({ theme }) => theme.spacing.km6};
  padding-right: ${({ theme }) => theme.spacing.km6};
  background-color: ${({ $variant, theme }) =>
    backgroundVariant($variant, theme)};
  border-radius: 16px;
  margin-top: ${({ theme }) => theme.spacing.km4};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const StatusTitle = styled(Text).attrs({ variant: 'h500' })`
  margin-bottom: ${({ theme }) => theme.spacing.km1};
`;

export const StatusDescription = styled(Text).attrs({
  color: 'neutral-strong',
})<StatusDescriptionProps>`
  ${({ theme, $isMarginParagraph }) =>
    $isMarginParagraph &&
    css`
      margin-top: ${theme.spacing.km4};
    `}
`;

export const Search = styled(DefaultSearch)`
  margin-right: ${({ theme }) => theme.spacing.km4};
`;

export const RedCancel = styled(DefaultRedCancel)`
  margin-right: ${({ theme }) => theme.spacing.km4};
`;

export const Column = styled(DefaultColumn)`
  flex: 1;
`;
